// extracted by css-extract-rspack-plugin
module.exports =  {"atfWrap":"w16iU","atfIn":"n3yxz","readmoreextend":"lx6tH","read_more":"fgXD9"};